// extracted by mini-css-extract-plugin
export default {"parent":"allproduct_parent__ctqGP","child":"allproduct_child__6StO8","name":"allproduct_name__reEzJ","headings":"allproduct_headings__SKMK5"};